import { AppThunk } from "@/redux/RootReducer";
import { fetchActualChangeForSinglePriceRow } from "../../thunks/FetchActualChangeForSinglePriceRow";

export const afterBulkUpdateRefresh =
  (
    routeAgreementId: string,
    routeAgreementPriceIdList: Array<string>
  ): AppThunk =>
  async (dispatch) => {
    await Promise.all(
      routeAgreementPriceIdList.map((routeAgreementPriceId) =>
        dispatch(
          fetchActualChangeForSinglePriceRow(
            routeAgreementId,
            routeAgreementPriceId
          )
        )
      )
    );
  };
